import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

import { Section } from '../PageLayout'

export const SupportedWirelessDevicesStyled = styled(Section)`
  .title {
    max-width: 930px;
    margin-bottom: 1.5rem;
  }

  .subtitle {
    max-width: 900px;
    margin-bottom: 1.5rem;
  }

  .description {
    margin-top: 1.5rem;
    text-align: left;
  }

  .btn-group {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    min-width: 650px;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;

    @media (max-width: ${breakpoints.screenMD}) {
      gap: 1rem;
      min-width: 580px;

      button {
        min-width: fit-content;
      }
    }

    @media (max-width: ${breakpoints.screenSM}) {
      flex-direction: column;
      min-width: 90%;
      margin-top: 0;

      button {
        width: 100%;
      }
    }
  }

  .devices {
    display: grid;
    grid-template-columns: ${({ $devicesNumber }) => `repeat(auto-fill, minmax(calc((100% / ${$devicesNumber}) - 1rem), 1fr))`};
    gap: 1rem;
    width: ${({ $maxWidth }) => $maxWidth};
    margin-top: 1.5rem;
    margin-bottom: 3rem;

    @media (max-width: ${breakpoints.screenMD}) {
      grid-template-columns: repeat(auto-fill, minmax(calc(33% - 1rem), 1fr));
    }

    @media (max-width: ${breakpoints.screenSM}) {
      grid-template-columns: repeat(auto-fill, minmax(calc(50% - 1rem), 1fr));
      width: 100%;
    }
  }

  .device {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  .img {
    display: flex;
    width: 120px;
    max-height: 120px;

    img {
      width: auto;
      height: 100%;
    }
  }
`
